
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.94 22.656c-3.3-.5-5.7 0-7.3-3.1-1.4-2.9-2.8-5.7-4.2-8.6-.1-.2-.2-.3-.3-.4-3.6-3.3-6.2 9.1-8 10.6-3.1 2.9-10.4-.2-13.4 3-3.2 3.5 4.9 9 6.6 10.8 2.2 2 2 1.1 1.5 4.1-.5 2.8-1.4 5.8-1.5 8.6-.1 6.5 6.8 1.1 9.6-.4 2.7-1.4 3.5-2.2 6.3-.8 2.4 1.3 5.7 3.9 8.4 4.4 4.8.9 2-7.8 1.6-10-.2-1.2-.8-2.8-.7-4 .1-1-.3-.1 1-1.2 2.3-2 4.8-4.2 6.7-6.6 4.4-5.2-2.5-5.9-6.3-6.4zm4.6 4.7l-2.6 2.6c-1.3 1.3-3.5 2.7-4.4 4.4-.9 1.6-.5 3.1-.2 4.8.3 2 2.1 6.7 1.5 8.6-.3 1 .3.6-1.2.1-1.1-.4-2.1-1.1-3.1-1.7-2-1.1-4.6-3.1-6.8-3.6-3.6-.8-8.3 3.7-11.5 5.1-1.4.6-1 1.1-1.4.1-.3-.8.5-3.2.7-4 .4-2.1 1.2-4.6 1.2-6.8 0-4.1-4.9-7-7.5-9.6-.2-.2-.6-.5-.9-.8 1.1-.4 2.5-.3 3.6-.5 2.3-.3 5.7-.1 7.7-1.1 1.8-.8 2.4-3 3.2-4.7.6-1.2 2.9-8.1 4.9-6.7l2.7 5.4c.7 1.4 1.4 4.1 2.7 5.2 2.9 2.6 8.8 1.2 12.5 2.4-.5.3-.9.7-1.1.8z"}})])
          )
        }
      }
    